import { render, staticRenderFns } from "./index-new.vue?vue&type=template&id=b532de16&scoped=true&"
import script from "./index-new.vue?vue&type=script&lang=js&"
export * from "./index-new.vue?vue&type=script&lang=js&"
import style0 from "./index-new.vue?vue&type=style&index=0&id=b532de16&prod&lang=css&"
import style1 from "./index-new.vue?vue&type=style&index=1&id=b532de16&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b532de16",
  null
  
)

export default component.exports